import { APIMethod, fetchData } from "@client";
import { mapKeysToSnakeCase } from "@client/api/utils/fetchApiUtils";

export async function reorderCompanyRateCardCategories(categoryId, newOrder, oldOrder) {
  return await fetchData(
    "/company/rate-card/categories/order",
    APIMethod.PATCH,
    {
      isJSONData: true,
      data: mapKeysToSnakeCase({
        categoryId,
        newOrder,
        direction: oldOrder > newOrder ? "up" : "down",
      }),
    }
  );
}
